import { Model } from "./Model";
import { Contact } from "./Contact";

export class Item extends Model {
  static props = {
    id: { type: Number, required: true },
    procurement_id: { type: Number },
    name: { type: String, required: true },
    contact_id: { type: Number },
    contact: { type: Contact },
    qty: { type: Number },

    pivot: { type: Object }
  };

  constructor(parameters) {
    super(Item.props, parameters);
  }

  get vendorName() {
    return this.contact && this.contact.name ? this.contact.name : "";
  }

  get vendorCompanyName() {
    return this.contact && this.contact.company_name
      ? this.contact.company_name
      : "";
  }

  get vendorNameWithCompany() {
    if (this.vendorCompanyName) {
      return this.vendorName
        ? `${this.vendorCompanyName} - ${this.vendorName}`
        : this.vendorCompanyName;
    }
    return this.vendorName;
  }
}
